module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/fridge/logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/fridge/logo.jpg
// module id = 566
// module chunks = 0